import React, { useEffect, useState } from "react";
import ShowImageComponent from "./ShowImageComponent";
import ExtractedData from "./ExtractedData";
import ExtractedTable from "./ExtractedTable";
import NoPreviewComponent from "./NoPreviewComponent";
import OVDComponent from "./OVDComponent";
import img1 from "../../assets/images/aadhaar.png";
import { Upload, Progress } from "@arco-design/web-react";
import { IconPlus, IconEdit } from "@arco-design/web-react/icon";
import PDFviewer from "../PDFViewerComponent/PDFviewer";
import ModalComponent from "../ModalComponent/Modal";
import {fileToPreviewUrl,  getLocalStorage } from "../../Functions/Utils";
import { Accordion } from "react-bootstrap";
import ExtractDataExpandable from "./ExtractDataExpandable";
import { ManageApis } from "../../AppServices/ManageApi";
import Loader from "../LoaderComponent/Loader";
import DownloadPreview from "./DownloadPreview";
import ExtractedDataListing from "./ExtractedDataListing";
import { DIRECTAIMENUS } from "../../globalData/constant";
import PrescriptionDataListing from "./PrescriptionDataListing";
import MedicalReportDataListing from "./MedicalReportDataListing";
import { useStoreValues } from "../../Context/storeProvider";
import PrescriptionDataListingV3 from "./PrescriptionDataListingV3";

function PreviewComponet({
  responseData = "",
  selectedMenu = "",
  selectedSide = "",
  setUploadSide,
  aofRefId = "",
  aofResponse = "",
  showAofDetails,
  
}) {
  const [file, setFile] = React.useState();
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setvisible] = useState({ show: false, preview: "" });
  const [previewImg, setPreviewImg] = useState("");
  const [previewData, setPreviewData] = useState("");
  const [isImage, setIsImage] = useState(false);
  const cs = `arco-upload-list-item${
    file && file.status === "error" ? " is-error" : ""
  }`;
  
  const { uploadedFile, setUploadedFile } = useStoreValues();
  useEffect(() => {
    console.log("dsadsa", responseData);
  }, [responseData]);
  let data;
  try {
    //
    // Attempt to parse responseData.result as JSON
    if (selectedMenu === "AADHARMASKING" && responseData) {
      let perses = responseData?.result
        ? responseData?.result
        : responseData?.message;
      const parsedResult = JSON.parse(perses);
      console.log(parsedResult);

      data = parsedResult?.detail.response_image;
    }
  } catch (error) {
    data = null;
    // console.error("Error parsing JSON:", error);
  }
  useEffect(() => {
    if(!DIRECTAIMENUS?.includes(selectedMenu)){
      handlePreviewShow(responseData?.id, true)
    }
  }, [responseData?.id]);

  useEffect(() => {
    const loadPreview = async () => {
      if (DIRECTAIMENUS?.includes(selectedMenu)) {
        let previewBase64 = getLocalStorage("currentBase64");

        if (previewBase64) {
          if (previewBase64.includes("image")) {
            setIsImage(true);
          } else {
            setIsImage(false);
          }
          if (selectedMenu === "MEDICALREPORT") {
            let preFile = fileToPreviewUrl(uploadedFile);
            setPreviewData(preFile);
            // just for client demo to test large file upload and response from ai, after 1 week we will remove the condition and code related to it
          } else if (selectedMenu === "PRESCRIPTIONOCR") {
            let preFile = fileToPreviewUrl(uploadedFile);
            setPreviewData(preFile);
          } else {
            setPreviewData(previewBase64);
          }
        }
      }
    };
    loadPreview();
  }, []);

  function getExtension(url) {
    const filename = url.substring(url.lastIndexOf("/") + 1);
    // Get the file extension by getting the part after the last '.'
    const fileExtension = filename.substring(filename.lastIndexOf(".") + 1);
    return fileExtension;
  }
  const classifyUrl = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
    const documentExtensions = ["pdf", "doc", "docx", "xls", "xlsx", "txt"];

    const fileExtension = getExtension(url).toLowerCase();

    if (imageExtensions.includes(fileExtension)) {
      return "image";
    } else if (documentExtensions.includes(fileExtension)) {
      return "document";
    } else {
      return "unknown";
    }
  };

  const handlePreviewShow = async (id, initial) => {
    console.log(responseData, id);
    if (initial) {
      let path = `/Upload/getOriginalImage?id=${id}`;
      setIsLoading(true);
      let preview_image = await ManageApis("get", path);
      console.log(preview_image);
      if (preview_image.message == "Success") {
        setIsLoading(false);
        setPreviewImg(preview_image?.response_data?.message);
      }
    } else
      setvisible((pre) => ({
        ...pre,
        show: true,
        preview: {
          type: "img",
          data: previewImg,
        },
      }));
  };

  const handlePreview = () => {
    setvisible((pre) => ({
      ...pre,
      show: true,
      preview: {
        type: "img",
        data: previewData,
      },
    }));
      
  };

  // Step 3: Add a download button that triggers the download function
  const handleDownload = () => {
    const base64String =
      typeof responseData.message == "string"
        ? JSON.parse(responseData?.message)?.data
        : "";
    //const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    //const linkSource = base64String;

    const downloadLink = document.createElement("a");
    console.log(linkSource);
    downloadLink.href = linkSource;
    downloadLink.target = "_blank";
    downloadLink.click();
  };
  const backOptionHandler = async () => {
    setUploadSide(true);
    localStorage.removeItem("currentBase64");
    setUploadedFile(null);
  };

  const renderPreviewComponent = () => {
    switch (selectedMenu) {
      case "OVDCLASSIFICATION":
        return (
          <OVDComponent
            responseData={responseData}
            setUploadSide={setUploadSide}
            previewImg={previewImg}
            previewIsImage={classifyUrl(previewImg) == "image"}
          />
        );
        break;
      case "FEDERALBANKACCOUNTOPENINGFORM":
        return (
          <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
            <div className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-7">
              <div className=" align-items-center  rounded  gap-2 ">
                <h2 className="font_16 fw-bold text-center mt-2 mb-2">
                  Uploaded Form
                </h2>

                <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                  {classifyUrl(previewImg) == "image" ? (
                    <img
                      src={
                        selectedMenu === "AADHARMASKING" //UPLOADED IMAGE
                          ? previewImg
                          : previewImg
                      }
                      className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                      onClick={() => handlePreviewShow(responseData?.id)}
                    />
                  ) : (
                    <PDFviewer imgPreview={previewImg} />
                  )}
                </div>
              </div>
              <div className="arco_custom_upload  mt-md-3 d-flex justify-content-center  pt-4">
                {/* <Upload> */}
                {/* <div className={cs}> */}

                <div
                  className="bg_master2 px-4 br_5 py-2 cursor-pointer"
                  onClick={() => {
                    setUploadSide(true);
                    localStorage.removeItem("currentBase64");
                    setUploadedFile(null);
                    
                  }}
                >
                  <div className="acro_custom_icon  d-flex align-items-center justify-content-center">
                    {/* <IconPlus /> */}
                    <div className="text-white ms-2">Try another file</div>
                  </div>
                </div>

                {/* </div> */}
                {/* </Upload> */}
              </div>
            </div>

            <div className="col-12 col-md-5 mt-3 mt-md-0">
              <div className="extracted_data_section">
                <ExtractDataExpandable
                  selectedMenu={selectedMenu}
                  responseData={responseData}
                  selectedSide={selectedSide}
                  aofRefId={aofRefId}
                  showAofDetails={showAofDetails}
                  aofResponse={aofResponse}
                />
              </div>
            </div>
          </div>
        );
        break;
      case "FEDERALBANKACCOUNTOPENINGFORMV2":
        return (
          <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
            <div className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-7">
              <div className=" align-items-center  rounded  gap-2 ">
                <h2 className="font_16 fw-bold text-center mt-2 mb-2">
                  Uploaded Form
                </h2>

                <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                  {classifyUrl(previewImg) == "image" ? (
                    <img
                      src={
                        selectedMenu === "AADHARMASKING" //UPLOADED IMAGE
                          ? previewImg
                          : previewImg
                      }
                      className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                      onClick={() => handlePreviewShow(responseData?.id)}
                    />
                  ) : (
                    <PDFviewer imgPreview={previewImg} />
                  )}
                </div>
              </div>
              <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                {/* <Upload> */}
                {/* <div className={cs}> */}

                <div
                  className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                  onClick={() => {
                    setUploadSide(true);
                    localStorage.removeItem("currentBase64");
                    setUploadedFile(null);
                  }}
                >
                  <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                    {/* <IconPlus /> */}
                    <div className="text-white ms-2">Try another file</div>
                  </div>
                </div>

                {/* </div> */}
                {/* </Upload> */}
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3 mt-md-0">
              <div className="extracted_data_section">
                <ExtractDataExpandable
                  selectedMenu={selectedMenu}
                  responseData={responseData}
                  selectedSide={selectedSide}
                  aofRefId={aofRefId}
                  showAofDetails={showAofDetails}
                  aofResponse={aofResponse}
                />
              </div>
            </div>
          </div>
        );
        break;

      case "TRANSCOMPDFEXTRATION":
        return (
          <>
            <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
              <div
                className={`bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 `}
              >
                <div className=" align-items-center  rounded  gap-2 ">
                  <div className="align-items-center d-flex justify-content-between mb-4 px-2">
                    <span></span>
                    <h2 className="font_16 fw-bold mb-0 mt-0 text-center">
                      Uploaded data
                    </h2>

                    <div
                      onClick={handleDownload}
                      className={`${
                        ["TRANSCOMPDFEXTRATION"].includes(selectedMenu)
                          ? "d-block"
                          : "d-none"
                      }  bg_master2 cursor-pointer px-3 py-2 rounded`}
                    >
                      <i class="fas fa-file-download font_16 text-white"></i>
                    </div>
                  </div>

                  <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                    {classifyUrl(previewImg) == "image" ? (
                      <img
                        src={
                          selectedMenu === "AADHARMASKING" //UPLOADED IMAGE
                            ? previewImg
                            : previewImg
                        }
                        className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                        onClick={() => handlePreviewShow(responseData?.id)}
                      />
                    ) : (
                      <PDFviewer imgPreview={previewImg} />
                    )}
                  </div>
                </div>
                <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                  {/* <Upload> */}
                  {/* <div className={cs}> */}

                  <div
                    className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                    onClick={() => {
                      setUploadSide(true);
                      localStorage.removeItem("currentBase64");
                      setUploadedFile(null);
                    }}
                  >
                    <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                      {/* <IconPlus /> */}
                      <div className="text-white ms-2">Try another file</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* this part not use in this case */}
              <div className="col-12 col-md-7 mt-3 mt-md-0 d-none">
                <div className="extracted_data_section">
                  {/* <ShowImageComponent image={selectedMenu === "Aadhar Masking"   //UPLOADED IMAGE
                ? responseData?.unmaskedImage]
                : [previewImg]} label={"UPLOADED DATA"} ImgClass={"img_t1"}/>            */}
                  {selectedMenu === "AADHARMASKING" ? (
                    <ShowImageComponent
                      image={[`data:image/jpeg;base64,${data}`]}
                      label={"Masked Image"}
                      ImgClass={"img_t1"}
                    /> //   MASKED IMAGE section end
                  ) : ["TRANSCOMPDFEXTRATION"].includes(selectedMenu) ? null : (
                    <ExtractedData
                      selectedMenu={selectedMenu}
                      responseData={responseData}
                      selectedSide={selectedSide}
                    /> //   EXTRACTED DATA section end
                  )}

                  {/* extracted table Section start */}
                  {/* <ExtractedTable/> */}
                  {/* extracted table Section end */}
                </div>
              </div>
            </div>
          </>
        );
        break;

      case "CANADIANDL":
        return (
          <>
            <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
              <div
                className={`bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5`}
              >
                <div className=" align-items-center  rounded  gap-2 ">
                  <div className="align-items-center d-flex justify-content-center mb-4 px-2">
                    <h2 className="font_16 fw-bold mb-0 mt-0 text-center">
                      Uploaded data
                    </h2>
                  </div>

                  <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                    {isImage ? (
                      <img
                        src={previewData}
                        className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                        onClick={() => handlePreview()}
                      />
                    ) : (
                      <PDFviewer imgPreview={previewData} />
                    )}
                  </div>
                </div>
                <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                  {/* <Upload> */}
                  {/* <div className={cs}> */}

                  <div
                    className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                    onClick={() => {
                      setUploadSide(true);
                      localStorage.removeItem("currentBase64");
                      setUploadedFile(null);
                    }}
                  >
                    <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                      {/* <IconPlus /> */}
                      <div className="text-white ms-2">Try another file</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* this part not use in this case */}
              <div className="col-12 col-md-7 mt-3 mt-md-0">
                <div className="extracted_data_section">
                    <ExtractedDataListing
                      responseData={responseData}
                    /> 
                </div>
              </div>
            </div>
          </>
        );
        break;
      case "DYNAMICOVDEXTRACTOR":
      case "UAEVISAOCR":
        return (
          <>
            <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
              <div
                className={`bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5`}
              >
                <div className=" align-items-center  rounded  gap-2 ">
                  <div className="align-items-center d-flex justify-content-center mb-4 px-2">
                    <h2 className="font_16 fw-bold mb-0 mt-0 text-center">
                      Uploaded data
                    </h2>
                  </div>

                  <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                    {isImage ? (
                      <img
                        src={previewData}
                        className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                        onClick={() => handlePreview()}
                      />
                    ) : (
                      <PDFviewer imgPreview={previewData} />
                    )}
                  </div>
                </div>
                <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                  {/* <Upload> */}
                  {/* <div className={cs}> */}

                  <div
                    className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                    onClick={() => {
                      setUploadSide(true);
                      localStorage.removeItem("currentBase64");
                      setUploadedFile(null);
                    }}
                  >
                    <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                      {/* <IconPlus /> */}
                      <div className="text-white ms-2">Try another file</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* this part not use in this case */}
              <div className="col-12 col-md-7 mt-3 mt-md-0">
                <div className="extracted_data_section">
                    <ExtractedDataListing
                      responseData={responseData}
                    /> 
                </div>
              </div>
            </div>
          </>
        );
        break;
      case "PRESCRIPTIONOCR":
      case "MEDICALREPORT":
        return (
          <>
            <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
              <div
                className={`bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5`}
              >
                <div className=" align-items-center  rounded  gap-2 ">
                  <div className="align-items-center d-flex justify-content-center mb-4 px-2">
                    <h2 className="font_16 fw-bold mb-0 mt-0 text-center">
                      Uploaded data
                    </h2>
                  </div>

                  <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                    {isImage ? (
                      <img
                        src={previewData}
                        className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                        onClick={() => handlePreview()}
                      />
                    ) : (
                      <PDFviewer imgPreview={previewData} />
                    )}
                  </div>
                </div>
                <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                  {/* <Upload> */}
                  {/* <div className={cs}> */}

                  <div
                    className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                    onClick={() => { backOptionHandler();}}
                  >
                    <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                      {/* <IconPlus /> */}
                      <div className="text-white ms-2">Try another file</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* this part not use in this case */}
              <div className="col-12 col-md-7 mt-3 mt-md-0">
                <div className="extracted_data_section">
                  {selectedMenu === "PRESCRIPTIONOCR" ? (
                    getLocalStorage("PRESCRIPTIONOCR_version") === "7.0" ? (
                      <PrescriptionDataListingV3 responseData={responseData} />
                    ) : (
                      <PrescriptionDataListing responseData={responseData} />
                    )
                  ) : (
                    <MedicalReportDataListing responseData={responseData} />
                  )}
                </div>
              </div>
            </div>
          </>
        );
        break;

      default:
        return (
          <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
            <div className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5">
              <div className=" align-items-center  rounded  gap-2 ">
                <h2 className="font_16 fw-bold text-center mt-2 mb-2">
                  Uploaded data
                </h2>

                <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 overflow-auto scrollbar1  p-1 br_15">
                  {classifyUrl(previewImg) == "image" ? (
                    <img
                      src={
                        selectedMenu === "AADHARMASKING" //UPLOADED IMAGE
                          ? previewImg
                          : previewImg
                      }
                      className=" object_fit_contain w-100 h-100  p-3 cursor-pointer preview_image"
                      onClick={() => handlePreviewShow(responseData?.id)}
                    />
                  ) : (
                    <PDFviewer imgPreview={previewImg} />
                  )}
                </div>
              </div>
              <div className="arco_custom_upload d-flex justify-content-center  pt-4">
                {/* <Upload> */}
                {/* <div className={cs}> */}

                <div
                  className="bg_master2 px-4 br_5  py-2 cursor-pointer"
                  onClick={() => {
                    setUploadSide(true);
                    localStorage.removeItem("currentBase64");
                    setUploadedFile(null);
                  }}
                >
                  <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                    {/* <IconPlus /> */}
                    <div className="text-white ms-2">Try another file</div>
                  </div>
                </div>

                {/* </div> */}
                {/* </Upload> */}
              </div>
            </div>

            <div className="col-12 col-md-7 mt-3 mt-md-0">
              <div className="extracted_data_section">
                {/* <ShowImageComponent image={selectedMenu === "Aadhar Masking"   //UPLOADED IMAGE
                ? responseData?.unmaskedImage]
                : [previewImg]} label={"UPLOADED DATA"} ImgClass={"img_t1"}/>            */}
                {selectedMenu === "AADHARMASKING" ? (
                  classifyUrl(previewImg) == "image" ?
                    <ShowImageComponent
                      image={[`data:image/jpeg;base64,${data}`]}
                      label={"Masked Image"}
                      ImgClass={"img_t1"}
                    /> //   MASKED IMAGE section end
                  :
                  <div className="h-100">
                    <h2 className="font_16 fw-bold text-center mt-2 mb-2">Masked Image</h2>
                    <div style={{height:'calc(100% - 40px)'}}>
                      <PDFviewer imgPreview={`data:application/pdf;base64,${data}`} />
                    </div>
                  </div>
                ) : (
                  <ExtractedData
                    selectedMenu={selectedMenu}
                    responseData={responseData}
                    selectedSide={selectedSide}
                  /> //   EXTRACTED DATA section end
                )}

                {/* extracted table Section start */}
                {/* <ExtractedTable/> */}
                {/* extracted table Section end */}
              </div>
            </div>
          </div>
        );
        break;
    }
  };

  return (
    <div className="reader__right w-100 pt-3 pt-md-0">
      {/* no preview section start */}
      {isLoading && <Loader />}
      {!responseData ? (
        setUploadSide(true) // no preview section end
      ) : (
        <>{renderPreviewComponent()}</>
      )}

      <ModalComponent
        show={visible.show}
        imgPreview={visible.preview}
        handleClose={() =>
          setvisible((pre) => ({ visible: false, preview: "" }))
        }
      />
    </div>
  );
}

export default PreviewComponet;
